var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47495 0.673243C5.2193 0.164672 4.54531 -0.106019 3.9012 0.0388961L0.979449 0.695117C0.40174 0.826361 0 1.25837 0 1.75054C0 8.51509 6.66025 14 14.8743 14C15.472 14 15.9966 13.6692 16.1559 13.1934L16.9528 10.7873C17.1287 10.2568 16.8 9.70175 16.1825 9.49121L12.9951 8.39751C12.4539 8.21158 11.8264 8.34009 11.4579 8.71469L10.1165 10.0627C7.77915 9.15217 5.88665 7.59364 4.78104 5.66873L6.41788 4.56682C6.87274 4.26059 7.02879 3.74655 6.80302 3.30086L5.47495 0.675977V0.673243Z",
    fill: "#F3E2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a110c259f1b9d07b80f50d054e1f7cae.svg";
export { ForwardRef as ReactComponent };